import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { getFuncionarios } from "./FuncionarioService";
import Select from "react-select";

const Utilitarios = ({ authResponseDTO, token }) => {
    const [funcionarios, setFuncionarios] = useState([]);

    useEffect(() => {
        getFuncionarios(token)
            .then((response) => {
                setFuncionarios(response);
            })
            .catch((error) => {
                console.error("Erro ao acessar api: ", error);
            });
    }, []);

    const labels = funcionarios.map((func) => func.nomeSobrenome);

    const data = {
        labels: labels,
        datasets: [
            {
                data: [
                    65, 59, 80, 81, 56, 55, 40, 50, 1, 59, 80, 81, 56, 55, 40,
                    50, 65, 59, 80, 81, 56, 55, 40, 50,
                ],
                backgroundColor: [
                    "rgba(0, 255, 255, 0.5)",
                    "rgba(199, 21, 133, 0.5)",
                    "rgba(154, 205, 50, 0.5)",
                    "rgba(138, 43, 226, 0.5)",
                    "rgba(255, 215, 0, 0.5)",
                    "rgba(0, 255, 255, 0.5)",
                    "rgba(199, 21, 133, 0.5)",
                    "rgba(154, 205, 50, 0.5)",
                    "rgba(138, 43, 226, 0.5)",
                    "rgba(255, 215, 0, 0.5)",
                    "rgba(0, 255, 255, 0.5)",
                    "rgba(199, 21, 133, 0.5)",
                    "rgba(154, 205, 50, 0.5)",
                    "rgba(138, 43, 226, 0.5)",
                    "rgba(255, 215, 0, 0.5)",
                ],
                borderWidth: 0,
            },
        ],
    };

    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
        plugins: {
            legend: {
                display: false,
            },
        },
    };

    const selectOptions = [
        {
            value: "1",
            label: "Particular",
        },
        {
            value: "2",
            label: "Convênio",
        },
        {
            value: "3",
            label: "Retorno",
        },
        {
            value: "4",
            label: "Cancelada",
        },
        {
            value: "5",
            label: "Em aberto",
        },
    ];

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 m-10">
                <div className="w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                    <div className="flex justify-between px-4 pt-4">
                        <h1 className="text-2xl font-bold">
                            Consultas por mês
                        </h1>
                        <div className="flex">
                            <Select
                                options={selectOptions}
                                placeholder="Tipo da consulta"
                            />
                            {/* <button
                                id="dropdownButton"
                                data-dropdown-toggle="dropdown"
                                className="ms-3 inline-block text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-1.5"
                                type="button"
                            >
                                <span className="sr-only">Open dropdown</span>
                                <svg
                                    className="w-5 h-5"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 16 3"
                                >
                                    <path d="M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
                                </svg>
                            </button> */}
                            {/* <!-- Dropdown menu --> */}
                            <div
                                id="dropdown"
                                className="z-10 hidden text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
                            >
                                <ul
                                    className="py-2"
                                    aria-labelledby="dropdownButton"
                                >
                                    <li>
                                        <a
                                            href="#"
                                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                                        >
                                            Edit
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                                        >
                                            Export Data
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            className="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                                        >
                                            Delete
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col items-center">
                        <Bar data={data} options={options} />
                    </div>
                </div>
                {/* <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-2.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-3.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-4.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-5.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-6.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-7.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-8.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-9.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-10.jpg"
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="h-auto max-w-full rounded-lg"
                        src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-11.jpg"
                        alt=""
                    />
                </div> */}
            </div>
        </>
    );
};

export default Utilitarios;
